export default {
  labelPrevDecade: 'Előző évtized',
  labelPrevYear: 'Következő évtized',
  labelPrevMonth: 'Előző hónap',
  labelCurrentMonth: 'Aktuális hónap',
  labelNextMonth: 'Következő hónap',
  labelNextYear: 'Következő év',
  labelNextDecade: 'Következő évtized',
  labelToday: 'Ma',
  labelSelected: 'Jelenlegi dátum',
  labelNoDateSelected: 'Válassz dátumot',
  labelCalendar: 'Naptár',
  labelNav: 'Navigáció',
  labelHelp: 'A nap kiválasztásához a nyílbillentyűket is használhatod.'
}